<template>
  <div class="categoryCardDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="grid__wrapper">
          <category-card v-for="(category, index) in categories" 
            :key="index" 
            :title="category.title" 
            :image="category.img" 
            :color="category.color" 
            :description="category.description" 
            :link="`home`"
            :pathName="`/home`"/>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import CategoryCard from '@/components/Card/CategoryCard'
import DocumentationContainer from '@/components/DocumentationContainer'
import GridCard from '@/components/Grid/Card'

export default {
  name: 'adx-category-card-doc',
  components: {
    'category-card': CategoryCard,
    'documentation-container': DocumentationContainer,
    'grid-card': GridCard
  },
  data() {
    return {
      title: 'Category Card',
      categories: [
        {
          title: 'SPBU',
          img: '/img/category/spbu.jpg',
          color: '#ff3b30',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Malls',
          img: '/img/category/mall.jpg',
          color: '#ff9500',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'InFlight',
          img: '/img/category/flight.jpg',
          color: '#007aff',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Airport',
          img: '/img/category/airport.jpg',
          color: '#4cd964',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Rideshare',
          img: '/img/category/rideshare.jpg',
          color: '#262626',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Lifestyle',
          img: '/img/category/lifestyle.jpg',
          color: '#5ac8fa',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Videotron',
          img: '/img/category/videotron.jpg',
          color: '#ffcc00',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
        {
          title: 'Cinema',
          img: '/img/category/cinema.jpg',
          color: '#d156d6',
          description: 'Phasellus sit amet enim erat. Sed tincidunt ultricies magna,'
        },
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>